import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../services/axios";
import { toast } from "react-toastify";

export const fetchCourses = createAsyncThunk(
  "course/fetchCourses",
  async () => {
    const response = await apiService.get("/course/all-courses",
      {},
      { skipErrorToast: true }
    );
    return response.data;
  }
);

export const createCourse = createAsyncThunk(
  "course/createCourse",
  async (courseData) => {
    const response = await apiService.post("/course/create", courseData);
    toast.success(response?.message || "Course created successfully");
    return response.data;
  }
);

export const updateCourse = createAsyncThunk(
  "course/updateCourse",
  async ({ courseId, courseName }) => {
    const response = await apiService.put("/course/update", {
      courseId: courseId,
      courseName: courseName,
    });
    toast.success(response?.message || "Course updated successfully");
    return response.data;
  }
);

const initialState = {
  courses: [],
  loading: false,
  error: null,
};

const courseSlice = createSlice({
  name: "course",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchCourses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCourses.fulfilled, (state, action) => {
        state.loading = false;
        state.courses = action.payload?.data || action.payload;
      })
      .addCase(fetchCourses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createCourse.pending, (state) => {
        state.loading = true;
      })
      .addCase(createCourse.fulfilled, (state, action) => {
        state.loading = false;
        state.courses.push(action.payload);
      })
      .addCase(createCourse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateCourse.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCourse.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.courses.findIndex(
          (c) => c._id === action.payload._id
        );
        if (index !== -1) {
          state.courses[index] = action.payload;
        }
      })
      .addCase(updateCourse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const selectCourses = (state) => {
  const courseState = state?.courses?.courses;
  if (!courseState) return [];
  if (Array.isArray(courseState)) return courseState;
  if (courseState.data && Array.isArray(courseState.data)) return courseState.data;
  return [];
};

export default courseSlice.reducer;
